import React from "react";
import logo from "../../assets/images/logo.png";
import arrowRight from "../../assets/images/auth/arrow-right.png";
const AuthBanner = () => {
  return (
    <div className="auth-banner  w-100 d-flex flex-column justify-content-between">
      <div className="d-flex">
        <img src={logo} alt="logo" className="auth-banner-logo" />
      </div>
      <div className="auth-banner-bottom ">
        <p className="poly text-white auth-banner-bottom-title mb-1">
          Welcome !
        </p>
        <div className="d-flex align-items-end justify-content-between">
          <p className="mb-0 text-white poppins f-16 lh-30 ">
            Create an account today and manage <br /> your beauty routine
          </p>
          <img src={arrowRight} />
        </div>
      </div>
    </div>
  );
};

export default AuthBanner;
